import {Component} from 'solid-js'
import {currencyFromPence} from '@peachy/utility-kit-pure'
import {InfoPanelNextPaymentDate} from '../pure/InfoPanelNextPaymentDate'
import {InfoPanelPlanStartDate} from '../pure/InfoPanelPlanStartDate'
import {MrSubscription} from '@peachy/core-domain-pure'
import {InfoPanel} from '../pure/InfoPanel'

export const BillingPaymentDetailsPanel: Component<{ subscription: MrSubscription }> = (props) => {
    return (
        <InfoPanel>
            <h5>{currencyFromPence(props.subscription.totalMonthlyPremium)}</h5>
            <InfoPanelNextPaymentDate nextPaymentDate={props.subscription.getNextPaymentDate()} />
            <InfoPanelPlanStartDate startDate={new Date(props.subscription.startDate)} />
        </InfoPanel>
    )
}
